import React, { useState } from 'react';

import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

import { getHmctsRecipient, getOrganizationRecipient, getSalesInvoiceRecipientInfo } from '../invoices/InvoiceData';

const PaymentPicker = ({ referrer, organization, tariff, items = [], onChange = () => {} }) => {
    const defaultRecipient = getSalesInvoiceRecipientInfo({ referrer, organization, tariff, items }) || {};
    const [hmcts] = useState(getHmctsRecipient());
    const [org] = useState(getOrganizationRecipient({ referrer, organization }));

    const [recipient, setRecipient] = useState(tariff.invoicee || defaultRecipient);

    const handleChange = name => {
        const invoicee = name === hmcts.name ? hmcts : org;
        setRecipient(invoicee);
        onChange(invoicee);
    }

    return (
        <FormControl fullWidth>
            <InputLabel>Who's paying?</InputLabel>
            <Select onChange={({ target: { value }}) => handleChange(value)} defaultValue={recipient.name || ''}>
                <MenuItem value={hmcts.name || ''} selected={recipient.name === hmcts.name} >{hmcts.name}</MenuItem>
                <MenuItem value={org.name || ''} selected={recipient.name === org.name}>{org.name}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default PaymentPicker;